"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var PricingRoles_1 = require("./PricingRoles");

var PromoRoles_1 = require("./PromoRoles");

var UserInfo_1 = require("./UserInfo");
/**
 * User identification within the application.
 *
 * @author Radek Beran
 */


var User =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(User, _DomainObject_1$Domai);

  function User(id, username, roles, permissions,
  /**
   * A substituted user if this user substitutes some user that is e.g. on vacation.
   * In such a case, this user has roles and permissions of substituted user and not
   * his/her own roles and permissions.
   */
  substitutedUser, name, firstName, lastName, email,
  /**
   * Date and time of last login, or null.
   */
  lastLogin) {
    var _this;

    _classCallCheck(this, User);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(User).call(this));
    _this.id = id;
    _this.username = username;
    _this.roles = roles;
    _this.permissions = permissions;
    _this.substitutedUser = substitutedUser;
    _this.name = name;
    _this.firstName = firstName;
    _this.lastName = lastName;
    _this.email = email;
    _this.lastLogin = lastLogin;
    return _this;
  }
  /** Short info about this user. */


  _createClass(User, [{
    key: "hasRole",
    value: function hasRole(role) {
      var roleNames = this.roles.map(function (r) {
        return r.name.toLowerCase();
      });
      return roleNames.contains(role.name.toLowerCase());
    }
  }, {
    key: "hasRoles",
    value: function hasRoles(roles) {
      var some = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var roleNames = this.roles.map(function (r) {
        return r.name.toLowerCase();
      });
      var roleCheckResult = roles.map(function (r) {
        return roleNames.contains(r.name.toLowerCase());
      });

      if (some) {
        return roleCheckResult.some(Boolean);
      }

      return roleCheckResult.every(Boolean);
    }
  }, {
    key: "hasPermission",
    value: function hasPermission(permission) {
      var permissionNames = this.permissions.map(function (p) {
        return p.name.toLowerCase();
      });
      return permissionNames.contains(permission.name.toLowerCase());
    }
  }, {
    key: "hasPermissions",
    value: function hasPermissions(permissions) {
      var some = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var permissionNames = this.permissions.map(function (p) {
        return p.name.toLowerCase();
      });
      var permissionCheckResult = permissions.map(function (p) {
        return permissionNames.contains(p.name.toLowerCase());
      });

      if (some) {
        return permissionCheckResult.some(Boolean);
      }

      return permissionCheckResult.every(Boolean);
    }
  }, {
    key: "isAdmin",
    value: function isAdmin() {
      return this.hasRoles([PricingRoles_1.PricingRoles.ADMIN, PromoRoles_1.PromoRoles.ADMIN, PromoRoles_1.PromoRoles.PROMO_SYSTEM_ADMIN], true);
    }
  }, {
    key: "userInfo",
    get: function get() {
      return new UserInfo_1.UserInfo(this.id, this.name);
    }
  }]);

  return User;
}(DomainObject_1.DomainObject);

exports.User = User;